module.exports = __webpack_public_path__ + "img/success_3.ef7cbfb0.gif";